// THE DESKTOP BREAKPOINT (launch-marketing-pages M9). The workspace picks its
// desktop shell at this width (`stores/workspaceLayout.js#isDesktop`), so the
// guided tour plays only from here up; the public showcase page reads the same
// number to send a narrower visitor to the tour's article instead
// (`views/public/ShowcasePage.vue`). No imports, so a public page takes it
// without pulling the workspace store into its graph.

/** The narrowest viewport, in CSS pixels, that gets the desktop workspace. */
export const DESKTOP_MIN_WIDTH = 1024;

/** The same breakpoint as a media query, for a `useMediaQuery` reader. */
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH}px)`;
